import { message } from '@/components';
import { useIntl } from 'umi';
import { useLocalStore } from 'mobx-react';
import { members as membersModel, rtc, simultaneousInterpretation } from '@/models';
import { InterpretationStatus, MainChannel } from '@/models/simultaneousInterpretation';
export interface InterpretationStatusChangeResp {
  interpretationStatus: number;
  channels: any[];
  channelId: number;
}

export default function useInterpretationStatusChange() {
  const { members, simultaneous } = useLocalStore(() => {
    return {
      rtc,
      simultaneous: simultaneousInterpretation,
      members: membersModel,
    };
  });
  const { formatMessage } = useIntl();

  const change = async (body: InterpretationStatusChangeResp, meetingId: string) => {
    const { interpretationStatus, channels = [], channelId } = body;
    console.log('通知---1501-----', body);
    console.log(
      '通知给定的同声传译状态--------',
      interpretationStatus,
      '---------当前的状态------',
      simultaneous.interpretationStatus,
      channels
    );
    // 当前返回的状态和之前的不一样 肯定是关闭或者开启了
    if (interpretationStatus !== simultaneous.interpretationStatus) {
      simultaneous.setInterpretationStatus(interpretationStatus);
      message.info({
        content: formatMessage({
          id:
            interpretationStatus === InterpretationStatus.starting
              ? 'INTERPRETATION_ENABLED'
              : 'INTERPRETATION_DISABLED',
        }),
        noIcon: true,
      });
      // 刷新频道列表
      simultaneous?.getChannels({
        meetingId: `${meetingId}`,
        channelId: `${channelId}`,
      });
      members.getInterpreters({ channelId });
    } else if (
      interpretationStatus === InterpretationStatus.starting &&
      interpretationStatus === simultaneous.interpretationStatus
    ) {
      console.log(
        '通知---1501---当前是开启--通知也是开启-----',
        interpretationStatus,
        simultaneous.interpretationStatus,
        channels
      );
      const oldList = (simultaneous.channels || []).map((item) => item.yxSubchannelName);
      const newList = channels.map((item) => item.yxSubchannelName);
      // 判断通知给的频道个数和本地存储是否一致,如果不一致就去更新频道信息
      if (oldList.sort().join() !== newList.sort().join()) {
        simultaneous?.getChannels({
          meetingId: `${meetingId}`,
          channelId: `${channelId}`,
        });
        members.getInterpreters({ channelId });
      }
      // 判断当前通知内是否有消失的频道,如果有判断是否是本地选择的,如果是 把本地频道改成主频道
      if (!newList.includes(simultaneous.curChannel) && simultaneous.curChannel !== MainChannel) {
        message.info({
          content: formatMessage({
            id: 'HOST_UPDATED_YOUR_LANGUAGE_PAIR',
          }),
          noIcon: true,
        });
        simultaneous.setCurChannel(MainChannel, '-1');
      }
    }
  };

  return change;
}
